import { $axAuthState } from '@/services/$axAuthStateManager'
import { $axFrontendHelper, AxTokenResponse } from '@/services/$axFrontendHelper'
import { $toast } from '@/services/$toast'
import { ColumnDef, ModelDef } from '@shared/model'
import { axApiPaths } from '@/AxApiPaths'
import { AxE2ConfigModelDef } from '../services/$AxE2Config'
import { axUserColumns, formatUserDataForAxRequest,formatNewPasswordDataForAxREquest } from './signup'
import { AxUser } from '@/types/AxUserType'
import { userColumns } from './_userColumns'
import { $Redirecter } from '@/services/redirecter'
import { cecPaths } from '@/cecSitePath'

export const userProfileColumn = {
    custom:{
      family_name:'',
      reputation:'',
      family_name_kana:'',
      reputation_kana:'',
      my_message:'',
      cloudK_memberid:'',
      credit_transfer_permisson:'',
      gmo_pg_member_id: '',
      // cumulative_amount:null,
      // membership_rank: '',
    },
    zip:'',
    state:'',
    city:'',
    street:'',
    building:'',
    birthday_y:'',
    birthday_m:'',
    birthday_d:'',
    tel_number1:'',
    tel_number2:'',
    tel_number3:'',
    email:'',
    password:'',
    password_confirm:'',
    gender:'',
    accept_makerepeater_mail:'',
}


export function makeColumns(): { [colName: string]: ColumnDef } {
  const except = ['id']
  const columns = {}
  try {
    Object.keys(userColumns).forEach((key) => {
      if (except.includes(key)) {
        return
      }
      columns[key] = userColumns[key]
    })
  } catch (e) {
    // 必要であればハンドリングを入れてください
  }
  return columns as { [colName: string]: ColumnDef }
}

const userProfileColumns = makeColumns()

export function userProfileFields(): string[] {
  const fields = axUserColumns.map((col) => `user.${col}`)
  return fields
}

export const getCurrentUserProfileData = async (): Promise<AxUser> => {
  try {
    const res = await $axFrontendHelper.request<{ user: AxUser }>({
      path: axApiPaths.users.get,
      data: {
        request: {
          fields: userProfileFields(),
        },
      },
    })
    return res.result.user
  } catch (e) {
    // $toast.error('会員情報の取得に失敗しました。')
  }
}

export const isProfileNext = () => {
  return false
}


export const onSubmitFunctions  = async(data) => {
    // ログイン状態チェック
    if (!$axAuthState.isLoggedIn) {
      $toast.error('ログインを行ってから再度やり直してください。')
      // 自動でログイン画面へリダイレクトする
      $Redirecter.openSite(cecPaths.accounts.login, false)
      return
    }

    try {
      data.new_password = data.password
      if (data.password !== null) {
        data.shouldChangePassword = true
      }
      if (data.shouldChangePassword) {
        // 送るとエラーになるため一旦退避
        delete data.password
      }
      const request = formatUserDataForAxRequest(data)
      const request_newpassword = data.new_password
      //ユーザの更新(パスワード以外)
      await $axFrontendHelper.request<AxTokenResponse>({
        path: axApiPaths.users.put,
        data: {
          query: {
            user: request,
          },
        },
      })

      //　ユーザの更新(パスワードの変更)
      if(request_newpassword){
        await $axFrontendHelper.request<AxTokenResponse>({
          path: axApiPaths.users.password.put,
          data: {
            query: {
              new_password: request_newpassword,
            },
          },
        })
      }
    } catch (e) {
      throw e
    }
  }


export const userProfile: ModelDef & AxE2ConfigModelDef<any> = {
  tableName: 'userProfile',
  tableLabel: 'プロフィール変更',
  defaultSort: { key: 'createdAt', order: 'desc' },
  timestamps: false,
  deletable: false,
  columns: userProfileColumns,
  onSubmitFunction:onSubmitFunctions
}

/*
  バリデーション処理
*/
export const validate = (data,errors,isChangePassword) => {
  const colDef = userColumns
  let col = {}
  let colData = {}
  errors.flag = false

  /* カラムカスタムは一度、カスタム名を削除し、再度、カスタムなしのカラム名にする
    例. custom.famlily_name →　famlily_name
        custom.reputation →　reputation
  */
  for(const keyname in data){
    if(keyname === 'custom'){
      for(const custom_keyname in data[keyname]){
        col[custom_keyname] = data[keyname][custom_keyname]
      }
    }
  }
  colData = Object.assign(col,data)
  delete colData['custom']

  // エラーチェック処理
  for(const keyname in colData){
    errors[keyname] = {}
    if(colDef[keyname] && colDef[keyname].validate){
      let err = []
      const passwordValidator = 'passwordValidator'
      const isNotEmptyPassword = 'isNotEmptyPassword'
      //classRemoveList(keyname)
      Object.keys(colDef[keyname].validate).map((key) => {
        let errormessage = '';
        const labelname = colDef[keyname].label

        // パスワードエラーチェック処理
        if(keyname === 'password' || keyname === 'password_confirm'){
          if(isChangePassword){
            if(key === 'sameWithPassword'){
              // パスワードが不一致の場合に処理
              errormessage = colDef[keyname].validate[key](colData[keyname],colData['password'])
            }else{
              // パスワード(空白、形式など)によるエラーチェック処理
              errormessage = colDef[keyname].validate[key](colData[keyname],labelname)
            }
          }
        }else{
          // パスワード以外エラーチェック処理
          errormessage = colDef[keyname].validate[key](colData[keyname],labelname)
        }
        // エラーメッセージがある場合にエラー内容を追加する
        if(errormessage){
          //console.log('errormessage: ', errormessage)
          err.push(errormessage)
          // debug
          // console.log(`エラー: ${keyname} => `+ labelname + ':' + errormessage)
        }
      })

      // エラーがある場合にエラーのフラグを有効
      if(err.length !== 0){
        //errors[keyname].message = err.join(',')
        errors[keyname].message = err
        // 各カラムのエラー有効
        errors[keyname].flag = true
        // 全カラムのエラー有効
        errors.flag = true
      }
    }
  }
}
